const ALLOWED_PROTOCOLS = new Set(['http:', 'https:']);

export const getSafeUrl = (value) => {
    if (typeof value !== 'string' || !value.trim()) return null;

    try {
        const url = new URL(value, window.location.origin);
        return ALLOWED_PROTOCOLS.has(url.protocol) ? url.href : null;
    } catch {
        return null;
    }
};
